import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import NumberInput from './NumberInput';

function NumberInputDemo() {
  const [initialValue, setValue] = React.useState<number | null | undefined>(
    null
  );

  const handleChange = (value: number | null | undefined) => {
    setValue(value);
  };
  return (
    <Container>
      <Container className="mt-10">
        <Row>
          <Col className="mt-10 p-0">
            <h4>Number Input</h4>
            <Container className="d-flex justify-content-between flex-wrap mt-10 p-0">
              <NumberInput
                icon={light('dollar')}
                placeholder={'0'}
                label={'Sample label'}
                className="mr-2"
                value={initialValue || 0}
                onChange={handleChange}
                minValue={'0'}
                maxValue={'100'}
              />
              <NumberInput
                icon={light('dollar')}
                placeholder={'0'}
                label={'Sample label'}
                className="mx-2"
                value={initialValue}
                onChange={handleChange}
              />
              <NumberInput
                icon={light('dollar')}
                placeholder={'0'}
                label={'Sample label'}
                disabled
                className="mx-2"
              />
              <NumberInput
                icon={light('dollar')}
                placeholder={'0'}
                label={'Sample label'}
                isValid={true}
                className="mx-2"
                value={initialValue}
                onChange={handleChange}
              />
              <NumberInput
                icon={light('dollar')}
                placeholder={'0'}
                label={'Sample label'}
                isInvalid={true}
                className="ml-2"
                value={initialValue}
                onChange={handleChange}
              />
            </Container>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default NumberInputDemo;
